import { all, call, fork, takeEvery, takeLatest } from 'redux-saga/effects';

import * as constants from './users.constants';
import * as types from './users.types';
import * as services from './users.saga-services';
import { watchUsersFormSaga } from './user-form/user-form.saga-watchers';

function* invokeSetupUsers(action: types.IFetchUsers) {
  yield call(services.setupUsers, action.payload);
}

function* invokeSignUpUser(action: types.ISignUpUser) {
  yield call(services.signUpUser, action.payload);
}

function* invokeCreateUser(action: types.ICreateUser) {
  yield call(services.createUser, action.payload.user);
}

function* invokeUpdateUser(action: types.IUpdateUser) {
  yield call(services.updateUser, action.payload.id, action.payload.data);
}

function* invokeUpdateUserEmail(action: types.IUpdateUserEmail) {
  yield call(services.updateUserEmail, action.payload);
}

function* invokeCheckUserExistence(action: types.ICheckUserExistence) {
  yield call(services.checkUserExistence, action.payload);
}

function* invokeDeleteUser(action: types.IDeleteUser) {
  yield call(services.deleteUser, action.payload);
}

function* invokeEnableUser(action: types.IEnableUser) {
  yield call(services.enableUser, action.payload);
}

function* invokeUpdateUserProfile(action: types.IUpdateUserProfile) {
  yield call(services.updateUserProfile, action.payload);
}

function* invokeSaveUserSocket(action: types.ISaveUserSocket) {
  yield call(services.handleUserFromNotification, action.payload);
}

function* invokeChangePassword(action: types.IChangepassword) {
  yield call(services.changePasswordUserProfile, action.payload.password);
}

function* invokeSyncUserWithSlack() {
  yield call(services.syncUserWithSlack);
}

export function* watchUsersPurePageSaga() {
  yield takeLatest(constants.FETCH_USERS, invokeSetupUsers);
  yield takeLatest(constants.CREATE_USER, invokeCreateUser);
  yield takeLatest(constants.UPDATE_USER, invokeUpdateUser);
  yield takeLatest(constants.CHECK_USER_EXISTENCE, invokeCheckUserExistence);
  yield takeLatest(constants.UPDATE_USER_EMAIL, invokeUpdateUserEmail);
  yield takeLatest(constants.CHANGE_PASSWORD, invokeChangePassword);
  yield takeLatest(constants.DELETE_USER, invokeDeleteUser);
  yield takeLatest(constants.ENABLE_USER, invokeEnableUser);
  yield takeLatest(constants.SIGNUP_USER, invokeSignUpUser);
  yield takeLatest(constants.UPDATE_USER_PROFILE, invokeUpdateUserProfile);
  yield takeLatest(constants.SYNC_USER_WITH_SLACK, invokeSyncUserWithSlack);

  yield takeEvery(constants.SAVE_USER_SOCKET, invokeSaveUserSocket);
}

export function* watchUsersPageSaga() {
  yield all([watchUsersPurePageSaga, watchUsersFormSaga].map(fork));
}
